import { expVal } from '@atlassian/jira-feature-experiments';
import { useIssueKey } from '@atlassian/jira-issue-context-service/src/main.tsx';
import { useProjectKey, useEdition } from '@atlassian/jira-project-context-service/src/main.tsx';
import { FREE_EDITION, STANDARD_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';

type useIsTwoStepIssueDeleteFreemiumExperimentEnabledProps = {
	isIssueArchivalEnabled?: boolean;
};

export const useIsTwoStepIssueDeleteFreemiumExperimentEnabled = ({
	isIssueArchivalEnabled = false,
}: useIsTwoStepIssueDeleteFreemiumExperimentEnabledProps) => {
	const issueKey = useIssueKey();
	const projectKey = useProjectKey(issueKey);
	const edition = useEdition(projectKey, true);

	const isUneligibleForIssueArchival =
		edition === FREE_EDITION || edition === STANDARD_EDITION || !isIssueArchivalEnabled;

	return (
		isUneligibleForIssueArchival &&
		expVal(
			'issue_deletion_two_step_process_for_free_standard',
			'isIssueDeleteExperimentFreemiumEnabled',
			false,
		)
	);
};
